import React from 'react';
import { Container } from 'react-bootstrap';
import './PerformanceMetricsStrip.css';

const keyMetrics = [
    { value: "95%", label: "Approval Rate" },
    { value: "5000+", label: "Happy Clients" },
    { value: "₹5 Cr+", label: "Loan Disbursed" },
    { value: "24/7", label: "AI Matching" },
    { value: "99.9%", label: "Uptime" },
    { value: "RBI", label: "Registered Partners" },
];

const PerformanceMetricsStrip = () => {
    // Duplicate metrics for smooth infinite scroll
    const metricsToRender = [...keyMetrics, ...keyMetrics];

    return (
        <section id="performance-metrics-strip" className="performance-metrics-strip py-4 py-md-5">
            <Container className="text-center mb-4">
                <h2 className="h4 performancemetrics-title mb-2">
                    Why Trust Us: <span className="text-gradient"> Our Performance & Metrics</span>
                </h2>
                <p className="performance-text-secondary small">
                    Join thousands of satisfied users benefiting from fast, secure, and smart financing.
                </p>
            </Container>

            <div className="logo-carousel-container">
                <div className="logo-carousel-track">
                    {metricsToRender.map((metric, index) => (
                        <div key={index} className="logo-slide">
                            <div className="metric-box">
                                <div className="metric-value">{metric.value}</div>
                                <div className="metric-label">{metric.label}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PerformanceMetricsStrip;
